import React from 'react';

import { IconEventWrapper, IconSwitcher } from '@repo/ui/components/Icon';
import LinkedinIcon from '@repo/ui/components/Icon/LinkedinIcon';

import { ShareWrapper } from './styles';
import { defaultTheme } from './theme';
import { ShareIconSwitcherProps } from './types';

const ShareIconSwitcher: React.FC<ShareIconSwitcherProps> = ({
  icon,
  iconHeight,
  wrapperHeight,
  theme: _theme,
  isActive,
  onClick,
}) => {
  const theme = { ...defaultTheme, ..._theme };
  return (
    <ShareWrapper
      size={wrapperHeight || '33px'}
      theme={theme}
      onClick={onClick}
    >
      <IconEventWrapper fitParent theme={theme}>
        <IconSwitcher
          height={
            iconHeight ? iconHeight : icon === LinkedinIcon ? '16px' : '19px'
          }
          icon={icon}
          isActive={isActive}
          theme={theme}
        />
      </IconEventWrapper>
    </ShareWrapper>
  );
};

export default ShareIconSwitcher;
